export default {
  zh: {
    weekShortAbbreviation: ["一", "二", "三", "四", "五", "六", "日"],
    weekAbbreviation: ["周一", "周二", "周三", "周四", "周五", "周六", "周日"],
    weekFullName: ["星期一", "星期二", "星期三", "星期四", "星期五", "星期六", "星期日"],
    monthAbbreviation: ["一", "二", "三", "四", "五", "六", "七", "八", "九", "十", "十一", "十二"],
    monthFullName: ["一月", "二月", "三月", "四月", "五月", "六月", "七月", "八月", "九月", "十月", "十一月", "十二月"],
    today: "今天",
    doneName: "完成",
    prevName: "上一页",
    nextName:"下一页"
  },
  es: {
    weekShortAbbreviation: ["L", "M", "W", "J", "V", "S", "D"],
    weekAbbreviation: ["Lun", "Mar", "Mie", "Jue", "Vie", "Sab", "Dom"],
    weekFullName: ["Lunes", "Martes", "Miercoles", "Jueves", "Viernes", "Sabado", "Domingo"],
    monthAbbreviation: ["Ene", "Feb", "Mar", "Abr", "May", "Jun", "Jul", "Ago", "Sept", "Oct", "Nov", "Dic"],
    monthFullName: [
      "Enero",
      "Febrero",
      "Marzo",
      "Abril",
      "Mayo",
      "Junio",
      "Julio",
      "Agosto",
      "Septiembre",
      "Octubre",
      "Noviembre",
      "Deciembre",
    ],
    today: "Hoy",
    doneName: "Listo",
    prevName: "Ant",
    nextName:"Sig"
  },
  en: {
    weekShortAbbreviation: ["M", "T", "W", "T", "F", "S", "S"],
    weekAbbreviation: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
    weekFullName: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"],
    monthAbbreviation: ["Jan", "Feb", "Mar", "Apr", "May", "June", "July", "Aug", "Sept", "Oct", "Nov", "Dec"],
    monthFullName: [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ],
    today: "Today",
    doneName: "Done",
    prevName: "Prev",
    nextName:"Next"
  },
  ru: {
    weekShortAbbreviation: ["П", "В", "С", "Ч", "П", "С", "В"],
    weekAbbreviation: ["Пн", "Вт", "Ср", "Чт", "Пт", "Сб", "Вс"],
    weekFullName: ["Понедельник", "Вторник", "Среда", "Четверг", "Пятница", "Суббота", "Воскресенье"],
    monthAbbreviation: ["Янв", "Фев", "Март", "Апр", "Май", "Июнь", "Июль", "Авг", "Сен", "Окт", "Ноя", "Дек"],
    monthFullName: [
      "Январь",
      "Февраль",
      "Март",
      "Апрель",
      "Май",
      "Июнь",
      "Июль",
      "Август",
      "Сентябрь",
      "Октябрь",
      "Ноябрь",
      "Декабрь",
    ],
    today: "Сегодня",
    doneName: "Готово",
    prevName: "Назад",
    nextName:"Вперед"
  },
  de: {
    weekShortAbbreviation: ["M", "D", "M", "D", "F", "S", "S"],
    weekAbbreviation: ["Mon", "Die", "Mit", "Don", "Fre", "Sam", "Son"],
    weekFullName: ["Montag", "Dienstag", "Mittwoch", "Donnerstag", "Freitag", "Samstag", "Sonntag"],
    monthAbbreviation: ["Jan", "Feb", "März", "Apr", "Mai", "Juni", "July", "Aug", "Sept", "Okt", "Nov", "Dez"],
    monthFullName: [
      "Januar",
      "Februar",
      "März",
      "April",
      "Mai",
      "Juni",
      "Juli",
      "August",
      "September",
      "Oktober",
      "November",
      "Dezember",
    ],
    today: "Heute",
    doneName: "Übernehmen",
    prevName: "Früher",
    nextName:"Später"
  },
  it: {
    weekShortAbbreviation: ["L", "M", "M", "G", "V", "S", "D"],
    weekAbbreviation: ["Lun", "Mar", "Mer", "Gio", "Ven", "Sab", "Dom"],
    weekFullName: ["Lunedí", "Martedí", "Mercoledí", "Giovedí", "Venerdí", "Sabato", "Domenica"],
    monthAbbreviation: ["Gen", "Feb", "Mar", "Apr", "Mag", "Giu", "Lug", "Ago", "Set", "Ott", "Nov", "Dic"],
    monthFullName: [
      "Gennaio",
      "Febbraio",
      "Marzo",
      "Aprile",
      "Maggio",
      "Giugno",
      "Luglio",
      "Agosto",
      "Settembre",
      "Ottobre",
      "Novembre",
      "Dicembre",
    ],
    today: "Oggi",
    doneName: "Fatto",
    prevName: "Prima",
    nextName:"Dopo"
  },
  el: {
  weekShortAbbreviation: ["Δ", "Τ", "Τ", "Π", ,"Π", "Σ", "Κ"],
  weekAbbreviation: ["Δευ", "Τρι", "Τετ", "Πεμ", "Παρ", "Σαβ", "Κυρ"],
  weekFullName: ["Δευτέρα", "Τρίτη", "Τετάρτη", "Πέμπτη", "Παρασκευή", "Σάββατο", "Κυριακή"],
  monthAbbreviation: ["Ιαν", "Φεβ", "Μαρ", "Απρ", "Μαι", "Ιουν", "Ιουλ", "Αυγ", "Σεπ", "Οκτ", "Νοε", "Δεκ"],
  monthFullName: [
    "Ιανουάριος",
    "Φεβρουάριος",
    "Μάρτιος",
    "Απρίλιος",
    "Μάιος",
    "Ιούνιος",
    "Ιούλιος",
    "Αύγουστος",
    "Σεπτέμβριος",
    "Οκτώβριος",
    "Νοέμβριος",
    "Δεκέμβριος",
  ],
  today: "Σήμερα",
  doneName: "Ολοκλήρωση",
  prevName: "Προηγ.",
  nextName:"Επόμ."
  },
  ro: {
    weekShortAbbreviation: ["L", "M", "M", "J", "V", "S", "D"],
    weekAbbreviation: ["Lun", "Mar", "Mie", "Joi", "Vin", "Sam", "Dum"],
    weekFullName: ["Luni", "Marti", "Miercuri", "Joi", "Vineri", "Sambata", "Duminica"],
    monthAbbreviation: ["Ian", "Feb", "Mar", "Apr", "Mai", "Iun", "Iul", "Aug", "Sep", "Oct", "Noi", "Dec"],
    monthFullName: [
      "Ianuarie",
      "Februarie",
      "Martie",
      "Aprilie",
      "Mai",
      "Iunie",
      "Iulie",
      "August",
      "Septembrie",
      "Octombrie",
      "Noiembrie",
      "Decembrie",
    ],
    today: "Astazi",
    doneName: "Terminat",
    prevName: "Precedent",
    nextName:"Urmator"
  },
};
